import apiClient from './apiClient';

function getErrorMessage(error, fallback) {
  return error.response?.data?.message || fallback;
}

function getFilenameFromDisposition(disposition, fallback) {
  const match = String(disposition || '').match(/filename="?([^"]+)"?/i);
  return match?.[1] || fallback;
}

function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

function buildRestoreFormData({ file, restoreMode, confirmation = '', previewToken = '' }) {
  const formData = new FormData();
  formData.append('backupFile', file);
  formData.append('restoreMode', restoreMode);

  if (confirmation) {
    formData.append('confirmation', confirmation);
  }

  if (previewToken) {
    formData.append('previewToken', previewToken);
  }

  return formData;
}

export async function fetchBackupCollections() {
  try {
    const response = await apiClient.get('/api/admin/backups/collections');

    return {
      collections: response.data.collections || [],
      totalCollections: response.data.totalCollections || 0,
      totalDocuments: response.data.totalDocuments || 0,
    };
  } catch (error) {
    throw new Error(getErrorMessage(error, 'Unable to load backup collections.'));
  }
}

export async function downloadBackupCollection(collectionName) {
  try {
    const response = await apiClient.get(
      `/api/admin/backups/collections/${encodeURIComponent(collectionName)}/download`,
      { responseType: 'blob' }
    );
    const filename = getFilenameFromDisposition(
      response.headers['content-disposition'],
      `factorstreet-${collectionName}.json`
    );

    downloadBlob(response.data, filename);

    return filename;
  } catch (error) {
    throw new Error(getErrorMessage(error, 'Unable to download collection backup.'));
  }
}

export async function previewBackupRestore(collectionName, file, restoreMode) {
  try {
    const response = await apiClient.post(
      `/api/admin/backups/collections/${encodeURIComponent(collectionName)}/preview-restore`,
      buildRestoreFormData({ file, restoreMode })
    );

    return response.data.preview;
  } catch (error) {
    throw new Error(getErrorMessage(error, 'Unable to preview restore.'));
  }
}

export async function finalBackupRestore(collectionName, file, restoreMode, confirmation, previewToken) {
  try {
    const response = await apiClient.post(
      `/api/admin/backups/collections/${encodeURIComponent(collectionName)}/final-restore`,
      buildRestoreFormData({ file, restoreMode, confirmation, previewToken })
    );

    return response.data.restored;
  } catch (error) {
    throw new Error(getErrorMessage(error, 'Unable to restore collection backup.'));
  }
}
